import { RouteEnum, generateRoutePath } from 'App';
import { SessionReviewUI } from '@shared';

export type RowType = {
  label: string;
  value: string;
  path?: string;
  uuid: string;
};

export const getRows = ({
  partner,
  course,
  exam,
  user,
  examSession,
  streamResponse,
  audits,
}: SessionReviewUI): RowType[] => [
  {
    label: 'Partner',
    value: partner.name,
    path: generateRoutePath({
      name: RouteEnum.Courses,
      params: { partner: partner.uuid },
    }),
    uuid: partner.uuid,
  },
  {
    label: 'Course',
    value: course.name,
    path: generateRoutePath({
      name: RouteEnum.Exams,
      params: { partner: partner.uuid, course: course.uuid },
    }),
    uuid: course.uuid,
  },
  {
    label: 'Exam',
    value: exam.name,
    path: generateRoutePath({
      name: RouteEnum.ExamSessions,
      params: { partner: partner.uuid, course: course.uuid, exam: exam.uuid },
    }),
    uuid: exam.uuid,
  },
  {
    label: 'Student',
    value: user.firstName + ' ' + user.lastName,
    uuid: user.uuid,
  },
  {
    label: 'Start Time',
    value: examSession.startTime,
    uuid: examSession.uuid + 'start',
  },
  {
    label: 'End Time',
    value: examSession.endTime,
    uuid: examSession.uuid + 'end',
  },
  {
    label: 'Audit Start Time',
    value: audits[0].startTime,
    uuid: audits[0].uuid + 'start',
  },
  {
    label: 'Audit End Time',
    value: audits[0].endTime,
    uuid: audits[0].uuid + 'end',
  },
  {
    label: 'Stream Detail',
    value: streamResponse.streamHandle,
    uuid: streamResponse.streamHandle + 'handle',
  },
  {
    label: 'Auditor Name',
    value: audits[0].auditorFullName,
    uuid: audits[0].uuid,
  },
];
